import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const PaginationBar = ({ currentPage, totalPages, totalItems, startIndex, endIndex, goToPage }) => {
  if (totalPages <= 1) return null;

  // Generate page numbers to show
  const getPageNumbers = () => {
    const pages = [];
    const maxShow = 5;
    let start = Math.max(1, currentPage - Math.floor(maxShow / 2));
    let end = Math.min(totalPages, start + maxShow - 1);
    if (end - start + 1 < maxShow) {
      start = Math.max(1, end - maxShow + 1);
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className="px-4 py-3 border-t border-gray-100 bg-gray-50/50 flex flex-col sm:flex-row items-center justify-between gap-2">
      <p className="text-xs sm:text-sm text-gray-500">
        Menampilkan <span className="font-medium text-gray-700">{startIndex}</span>–<span className="font-medium text-gray-700">{endIndex}</span> dari{' '}
        <span className="font-medium text-gray-700">{totalItems}</span> data
      </p>
      <div className="flex items-center space-x-1">
        <button
          onClick={() => goToPage(1)}
          disabled={currentPage === 1}
          className="px-2 py-1.5 text-xs font-medium text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded-lg disabled:opacity-30 disabled:cursor-not-allowed transition-all"
          title="Halaman pertama"
        >
          <ChevronLeft className="w-3.5 h-3.5 inline-block -mr-1" />
          <ChevronLeft className="w-3.5 h-3.5 inline-block" />
        </button>
        <button
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-2 py-1.5 text-xs font-medium text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded-lg disabled:opacity-30 disabled:cursor-not-allowed transition-all"
        >
          <ChevronLeft className="w-3.5 h-3.5" />
        </button>

        {getPageNumbers().map(page => (
          <button
            key={page}
            onClick={() => goToPage(page)}
            className={`min-w-[32px] px-2 py-1.5 text-xs font-medium rounded-lg transition-all ${
              page === currentPage
                ? 'bg-blue-600 text-white shadow-sm'
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-200'
            }`}
          >
            {page}
          </button>
        ))}

        <button
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-2 py-1.5 text-xs font-medium text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded-lg disabled:opacity-30 disabled:cursor-not-allowed transition-all"
        >
          <ChevronRight className="w-3.5 h-3.5" />
        </button>
        <button
          onClick={() => goToPage(totalPages)}
          disabled={currentPage === totalPages}
          className="px-2 py-1.5 text-xs font-medium text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded-lg disabled:opacity-30 disabled:cursor-not-allowed transition-all"
          title="Halaman terakhir"
        >
          <ChevronRight className="w-3.5 h-3.5 inline-block -mr-1" />
          <ChevronRight className="w-3.5 h-3.5 inline-block" />
        </button>
      </div>
    </div>
  );
};

export default PaginationBar;
